/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDialogAlert120 = forwardRef<SVGSVGElement, IconBaseProps>(function IconDialogAlert120(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 120 120" ref={ref}>
            <path
                d="M60 110c27.614 0 50-22.386 50-50S87.614 10 60 10 10 32.386 10 60s22.386 50 50 50ZM37.015 37.014a5 5 0 0 1 7.071 0L60.001 52.93l15.914-15.915a5 5 0 1 1 7.071 7.072L67.072 60l15.914 15.915a5 5 0 1 1-7.071 7.07L60 67.072 44.087 82.986a5 5 0 1 1-7.071-7.072L52.929 60 37.015 44.086a5 5 0 0 1 0-7.072Z"
                fill="#D00"
            />
        </SVGContainer>
    );
});

export const IconDialogAlert = forwardRef<SVGSVGElement, IconBaseProps>(function IconDialogAlert(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '120':
            return <IconDialogAlert120 {...iconProps} />;
        default:
            return <IconDialogAlert120 {...iconProps} />;
    }
});
